var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4113 0.9H2.47303C1.62278 0.9 0.9 1.5857 0.9 2.47303L0.9 15.8376L0.9 15.8378C0.902553 16.9859 2.30148 17.5167 3.09296 16.717C3.09303 16.7169 3.0931 16.7168 3.09316 16.7168L6.5379 13.273L6.53792 13.273L6.53939 13.2715C6.77611 13.0245 7.20819 13.0245 7.44491 13.2715L7.44489 13.2715L7.4464 13.273L10.8911 16.7168C10.8912 16.7168 10.8913 16.7169 10.8913 16.717C11.6831 17.5171 13.0819 16.9854 13.0843 15.8378V15.8376V2.47303C13.0843 1.5857 12.3615 0.9 11.5113 0.9H11.4113ZM11.6972 15.9141L11.6972 15.9141L11.6953 15.9122C11.0068 15.2226 9.04381 13.2602 8.25214 12.47C7.59056 11.7791 6.39474 11.7789 5.73339 12.4687C5.18934 13.0118 4.12808 14.0727 3.28721 14.9133L3.27469 14.9259L3.27468 14.9259L2.29367 15.9064L2.29364 15.9064L2.29159 15.9086C2.2472 15.9557 2.17958 15.9717 2.12444 15.9576C2.0752 15.945 2.03914 15.9105 2.03755 15.845V2.47303C2.03755 2.22962 2.23469 2.03758 2.47303 2.03758H11.5112C11.7492 2.03758 11.9467 2.22934 11.9467 2.47303V15.8374C11.9463 15.9 11.9103 15.9393 11.8592 15.9553C11.8047 15.9724 11.7403 15.9596 11.6972 15.9141Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark-icon.6d1c2c1d0dfc7822f4bf9b194c1f7fdd.svg";
export { ForwardRef as ReactComponent };